export const VIRAL_LOOPS_LOADER_ID = 'viral-loops-loader';
export const VIRAL_LOOPS_SCRIPT_SRC = 'https://app.viral-loops.com/widgetsV2/core/loader.js';
